import PanelHeader from './PanelHeader.jsx';

export default PanelHeader;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/FullScreenPanel/PanelHeader/index.js